import React from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import PageLoader from './ui/PageLoader';

interface ProtectedAdminRouteProps {
  children: React.ReactNode;
}

export const ProtectedAdminRoute: React.FC<ProtectedAdminRouteProps> = ({ children }) => {
  const { isAuthenticated, isSuperAdmin, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <PageLoader message="Checking access…" />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (!isSuperAdmin) {
    return (
      <div className="page flex items-center justify-center px-4">
        <div className="max-w-md mx-auto text-center card p-8">
          <h2 className="heading-section text-red-400 mb-2">Access denied</h2>
          <p className="text-gray-300 mb-4 text-sm">
            Super admin privileges are required for this area.
          </p>
          <Link to="/" className="btn-secondary btn-md inline-flex">
            Back to Bilt:Spec
          </Link>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
